/**
 * 描述：辅助编辑个人素材
 * 日期：2017-10-17
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('scPersonalMaterialModule', []).directive('scPersonalMaterial', [
    'initVersionService',
    'alterModule',
    '$filter',
    '$stateParams',
    'ueditorService',
    'mrApiService',
    function(initVersionService, alterModule, $filter, $stateParams, ueditorService, mrApiService) {
        return {
            replace: true,
            restrict: 'E',
            scope: false,
            templateUrl: './editingCenter/directive/supportCreation/personalMaterial/personalMaterial_tpl.html',
            link: function(scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    var status = {
                        gerensucai_search: false,
                        showTimeline: true,
                        creationAxisItems: [],
                        Keywords: '',
                    };
                    var data = {
                        typeList: [
                            {
                                name: '图片',
                                value: '0',
                            },
                            {
                                name: '音频',
                                value: '1',
                            },
                            {
                                name: '视频',
                                value: '2',
                            },
                            {
                                name: '文字',
                                value: '3',
                            },
                        ],
                        docid: window.location.href.indexOf('metadataid') > -1 ? getMetadataid() : '0',
                    };
                    var page = {
                        creationAxis: {
                            CURRPAGE: 1,
                            PAGESIZE: 100,
                            PAGECOUNT: '',
                        },
                    };
                    var message = {
                        creationAxisHasNoMore: false,
                    };
                    angular.extend(scope.status, status);
                    angular.extend(scope.data, data);
                    angular.extend(scope.status.page, page);
                    angular.extend(scope.status.message, message);
                    scope.data.selectType = scope.data.typeList[0].value;
                }

                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    queryMaterials(false);
                }

                /**
                 * [getMetadataid description] 初始化数据
                 * @return {[type]} [description]
                 */
                function getMetadataid() {
                    var a;
                    for (var i in $stateParams) {
                        if (i.indexOf('metadataid') > -1) {
                            a = i;
                            break;
                        }
                    }
                    return $stateParams[a];
                }

                /**
                 * [handleHtmlContent description] 处理html正文
                 * @param {object} [item] [description] 被处理的项
                 * @return {[type]} [description]
                 */
                scope.handleHtmlContent = function(item) {
                    if (item.value && item.value.HTMLCONTENT && item.value.FILETYPE == '1') {
                        item.value.HTMLCONTENT = $(item.value.HTMLCONTENT).text();
                    }
                    if (item.value && item.value.HTMLCONTENT && item.value.FILETYPE == '4') {
                        item.value.HTMLCONTENTSHOW = item.value.HTMLCONTENT.replace(/\n/g, '<br/>');
                    }
                };

                /**
                 * [playVideoOrAudio description] 点击播放音视频
                 * @param   {[type]}  id    [id description] 音/视频
                 * @param   {[type]}  type  [type description] 被处理的项
                 * @return  {[type]}        [return description]
                 */
                scope.playVideoOrAudio = function(id, type, relationid, meiziid) {
                    ueditorService.videoPlayer(id, type, relationid, meiziid);
                };

                /**
                 * [initData description] 按类别查询创作轴
                 * @param  {type}  [description:创作轴类别]
                 */
                /**
                 * [searchByType description] 按类别查询创作轴
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                scope.searchByType = function(item) {
                    scope.data.selectType = item.value;
                    scope.status.page.creationAxis.CURRPAGE = 1;
                    scope.status.Keywords = '';
                    queryMaterials(false);
                };

                /**
                 * [transferMaterialData 将素材库数据转换为创作轴需要的数据格式]
                 * @param   {[type]}  data  [data description]
                 * @return  {[type]}        [return description]
                 */
                function transferMaterialData(data) {
                    let DATA = [];
                    data.forEach(function(element, index) {
                        var baseObj, tmpObj;
                        if (element.resourcetype === 0) { // 图片
                            baseObj = packageBaseAttr(element);
                            tmpObj = angular.extend({}, baseObj, {
                                SRCIMGURL: element.previewurl || element.thumbimg || element.resourceurl,
                            });
                        } else if (element.resourcetype === 1) { // 音频
                            baseObj = packageBaseAttr(element);
                            tmpObj = angular.extend({}, baseObj, {
                                resourcetype: 'audio',
                                VIDEOID: element.transferid,
                                videoUrl: !element.thumbimg || element.thumbimg === '' ? './static/audio_default.jpg' : element.thumbimg,
                                playurl: element.previewurl, // 播放地址
                            });
                        } else if (element.resourcetype === 2) { // 视频
                            baseObj = packageBaseAttr(element);
                            tmpObj = angular.extend({}, baseObj, {
                                resourcetype: 'video',
                                VIDEOID: element.transferid,
                                videoUrl: !element.thumbimg || element.thumbimg === '' ? './images/video_default.png' : element.thumbimg,
                                playurl: element.previewurl, // 播放地址
                            });
                        } else if (element.filetype === '1') {
                            // baseObj = packageWordBaseAttr(element);
                            // tmpObj = angular.extend({}, baseObj, {
                            //     FILETYPE: 1,
                            // });
                            tmpObj = {
                                filesize: element.filesize,
                                CRTIME: element.crtime,
                                OPRTIME: element.oprtime || '',
                                TENANTID: element.tenantid,
                                FILETYPE: '1',
                                HTMLCONTENT: element.htmlcontent || '',
                                STATUS: element.status || '0',
                                PERSONALMATERIALID: element.personalmaterialid || '0',
                                PARENTID: element.parentid || '0',
                                FILEDESC: element.filedesc || '',
                                CRUSER: element.cruser || '',
                            };
                        } else if (element.filetype === '4') {
                            // baseObj = packageWordBaseAttr(element);
                            // tmpObj = angular.extend({}, baseObj, {
                            //     FILETYPE: 4,
                            // });
                            tmpObj = {
                                filesize: element.filesize,
                                CRTIME: element.crtime,
                                OPRTIME: element.oprtime || '',
                                TENANTID: element.tenantid,
                                FILETYPE: '4',
                                HTMLCONTENT: element.htmlcontent || '',
                                STATUS: element.status || '0',
                                PERSONALMATERIALID: element.personalmaterialid || '0',
                                PARENTID: element.parentid || '0',
                                FILEDESC: element.filedesc || '',
                                CRUSER: element.cruser || '',
                            };
                        }
                        if (tmpObj) {
                            DATA[index] = tmpObj;
                        }
                    });
                    return DATA;
                }

                /**
                 * [packageBaseAttr description] 组装基础参数 （除文字）
                 * @param   {[object]}  element  [element description] 素材信息
                 * @return  {[type]}             [return description]
                 */
                function packageBaseAttr(element) {
                    return {
                        FILESIZE: String(element.resourcesize),
                        CRTIME: element.savetime,
                        OPRTIME: '',
                        TENANTID: element.tenantid,
                        FILETYPE: getFileType(element.resourcetype),
                        HTMLCONTENT: '',
                        STATUS: '0',
                        PARENTID: '0',
                        FILEDESC: element.content || '',
                        CRUSER: 'test@trs.com',
                        FILENAME: element.resourcetitle || '',
                        PERSONALMATERIALID: element.relationid,
                        resourceid: element.resourceid,
                        relationid: element.relationid,
                    };
                }

                /**
                 * [packageWordBaseAttr description] 组装文字基础信息
                 * @param   {[object]}  element  [element description] 素材信息
                 * @return  {[type]}             [return description]
                 */
                function packageWordBaseAttr(element) {
                    return {
                        filesize: element.filesize,
                        CRTIME: element.crtime,
                        OPRTIME: element.oprtime || '',
                        TENANTID: element.tenantid,
                        HTMLCONTENT: element.htmlcontent || '',
                        STATUS: element.status || '0',
                        PERSONALMATERIALID: element.personalmaterialid || '0',
                        PARENTID: element.parentid || '0',
                        FILEDESC: element.filedesc || '',
                        CRUSER: element.cruser || '',
                    };
                }

                /**
                 * [getFileType 获取素材对应的类型]
                 * @param   {[type]}  resourcetype  [resourcetype 素材库类型]
                 * @return  {[type]}                [return 创作轴类型]
                 */
                function getFileType(resourcetype) {
                    var map = {
                        0: '2',
                        1: '5',
                        2: '3',
                        3: '4',
                    };
                    return map[resourcetype];
                }

                /**
                 * [SearchThroughKeywords description] 按关键字查询创作轴
                 * @param   {[type]}  e  [e description]
                 * @return  {[type]}     [return description]
                 */
                scope.SearchThroughKeywords = function(e) {
                    if (e.keyCode == '13') {
                        scope.status.page.creationAxis.CURRPAGE = 1;
                        queryMaterials(false);
                    } else {
                        return;
                    }
                };

                /**
                 * [selectAudioVideo description] 过滤没法播放的音频、视频
                 * @param   {[object]}  item  [item description] 素材信息
                 * @return  {[type]}          [return description]
                 */
                scope.selectAudioVideo = function(item) {
                    return (angular.isUndefined(item.previewurl) || item.previewurl !== null);
                    // 图片、音视频都是通过previewurl展示，previewurl有效的才展示，文字没有previewurl
                };

                /**
                 * [queryMaterials 获取素材库个人素材]
                 * @param   {[type]}  isGetMore  [isGetMore description]
                 * @return  {[type]}             [return description]
                 */
                function queryMaterials(isGetMore) {
                    let params = mrApiService.resetSearchparams();
                    let curentParams = {
                        mrType: 'personal',
                        mainResourceType: scope.data.selectType,
                        pageNum: scope.status.page.creationAxis.CURRPAGE,
                        name: scope.status.Keywords,
                        isPureMaterial: 1, // 是否纯素材，2-纯素材，0-全部素材,1-素材+图集
                        uploadStatus: 1, // 表示都是转码成功的音视频
                        // checkStatus: 1, // 只请求审核通过的素材
                    };
                    scope.loadingPromise = mrApiService.getMaterialData(angular.extend({}, params, curentParams), true).then(function(data) {
                        if (!data.datas) {
                            return;
                        }
                        // let mydata = $filter('pick')(data.datas, scope.selectAudioVideo);
                        let mydata = transferMaterialData(data.datas);
                        if (!!isGetMore) {
                            scope.status.creationAxisItems = scope.status.creationAxisItems.concat(initVersionService.getDayContent(mydata, true));
                        } else {
                            scope.status.creationAxisItems = initVersionService.getDayContent(mydata, true);
                        }
                        scope.status.page.creationAxis = transferPage(data.summary_info);
                        scope.status.message.creationAxisHasNoMore =
                            scope.status.page.creationAxis.CURRPAGE >= scope.status.page.creationAxis.PAGECOUNT;
                    });
                }

                /**
                 * [transferPage 将媒资库分页数据转换为创作轴数据格式]
                 *
                 * @param   {[type]}  pageInfo  [pageInfo description]
                 *
                 * @return  {[type]}            [return description]
                 */
                function transferPage(pageInfo) {
                    return {
                        CURRPAGE: parseInt(pageInfo.pageNum),
                        PAGESIZE: parseInt(pageInfo.pageSize),
                        PAGECOUNT: pageInfo.total === 0 ? 0 : Math.ceil(pageInfo.total / parseInt(pageInfo.pageSize)),
                    };
                }

                /**
                 * [getMoreCreationAxis description] 创作轴加载更多
                 * @return  {[type]}  [return description]
                 */
                scope.getMoreCreationAxis = function() {
                    if (scope.status.page.creationAxis.CURRPAGE >= scope.status.page.creationAxis.PAGECOUNT) {
                        return;
                    }
                    scope.status.page.creationAxis.CURRPAGE += 1;
                    queryMaterials(true);
                };

                /**
                 * [creationOpen description] 创作轴新窗口
                 * @param   {[type]}  ceratiid  [ceratiid description]
                 * @return  {[type]}            [return description]
                 */
                scope.creationOpen = function(ceratiid) {
                    alterModule.creationDetail(ceratiid.value.PERSONALMATERIALID);
                };

                /**
                 * 拖动开始时，记录信息
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                scope.dragStart = function(item) {
                    return item;
                };

                /**
                 * 拖动开始时，记录信息，报纸编辑页专用，替换CREATIONTYPE
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                scope.fakeDragStart = function(item) {
                    var fakeItem = angular.copy(item);
                    fakeItem.value.CREATIONTYPE = '2';
                    return fakeItem;
                };
            },
        };
    },
]);
